var $ = require("jquery");
var con = require("./_content");
var code = require("./_checkcode");
// require("./_player");
require("./_reply");
var QRCode = require("qrcode");
console.log("开始运行");
// https://alifile.yibinrm.cn/media/2026-05-16/235564514/712ABA0AC83C9CEE05B2EA7B4A0861AAM3U8.m3u8
// get_reply 获取回复
// submitQuestion 提交问卷,submitVote 提交投票,submitSignup 提交报名

var players = [];
var infoAnonymous = true;
var enableCaptcha = false;
var eventStart = null;
var eventEnd = null;
var dayLimit = 0;
var totalLimit = 0;

$(function () {
    var column_id = $("#info_column_id").val();
    initCnzz();
    getAds();
    getReply(replyPage);
    //getDownloadInfo();//隐藏
    getHots();
    getTabNews();
    // setTimeout(() => {
    //     getHots();
    //     getTabNews();
    // }, 500);
    // getNewest();//最新内容隐藏
    // getCorrelates();//相关推荐隐藏
    var columns = getColumnIndex(column_id);

    if (columns) {
        $(".column").html(columns);
    }
    let mobileContentUrl = $(".info-weixin").attr("data-url");
    if (mobileContentUrl) {
        QRCode.toDataURL(
            mobileContentUrl,
            {
                type: "image/png",
            },
            function (err, url) {
                $(".info-weixin-qrcode").attr("src", url);
            }
        );
    }

    // $('.correlates-change').on('click', function () {
    //     getCorrelates();
    // });

    $(".abs-reply").on("click", function () {
        $(".user_reply").focus();
        if ($(".top .top-login").length > 0) {
            showLogin();
            return;
        }
    });

    $(".abs-collect").on("click", function () {
        if ($(".top .top-login").length > 0) {
            showLogin();
            return;
        }
    });

    $(".news-tab-nav span").on("click", function () {
        let type = $(this).attr("data-type");
        $(this).addClass("active").siblings().removeClass("active");
        getTabNews(type);
    });

    var num = 0;
    var type = $("#info_type").val();
    var extension = $("#info_extension").val();
    if (extension) extension = JSON.parse(extension);
    console.log(extension);
    var now = Date.now() / 1000;

    var components = $("#info_body_components").val();
    if (components) {
        components = JSON.parse(components);
        con.setcontentinfo(components);
        var body = $("#content_body").html();
        body = con.geteditorbody(body);
        console.log(body);
        $("#content_body").html(body);
        for (var i = 0; i < $(".content-live").length; i++) {
            var id = $($(".content-live")[i]).attr("data-src");
            var urls = con.playlive(id);
            var playerid = "player-live-" + id;

            $($(".content-live")[i]).html(
                '<video id="' +
                    playerid +
                    '" number="' +
                    num++ +
                    '" style="min-width: 800px; min-height: 640px;" class="video-js vjs-big-play-centered"></video>'
            );
            var play;
            play = startPlay(urls[0], playerid, false);
            players.push(play);
        }
        for (var i = 0; i < $(".content-video").length; i++) {
            var id = $($(".content-video")[i]).attr("data-src");
            var urls = con.playvideo(id);
            urls.sort(function (a, b) {
                if (a.substr(-5) == ".m3u8") return -1;
                else if (b.substr(-5) == ".m3u8") return 1;
                else return 0;
            });
            var playerid = "player-video-" + id;

            $($(".content-video")[i]).html(
                '<video id="' +
                    playerid +
                    '" number="' +
                    num++ +
                    // '" style="min-width: 766px; min-height: 640px;" class="video-js vjs-big-play-centered"></video>'
                    '" style="width:100%; min-height: 580px;" class="video-js vjs-big-play-centered"></video>'
            );
            var play;
            play = startPlay(urls[0], playerid, false);
            players.push(play);
        }
        for (var i = 0; i < $(".content-audio").length; i++) {
            var id = $($(".content-audio")[i]).attr("data-src");
            var obj = con.playaudio(id);
            if (obj == null) continue;
            var playerid = "player-audio-" + id;

            $($(".content-audio")[i]).html(
                '<video id="' +
                    playerid +
                    '" number="' +
                    num++ +
                    '" style="width: 800px; height: 50px;" class="video-js vjs-big-play-centered"></video>'
            );
            var play;
            play = startPlay(obj.strAudioUrl, playerid, false);
            players.push(play);
        }
        $(".like-button").css("display", "block");
    }
    if (type == "video") {
        if (extension && extension.videos.length > 0) {
            $("#content_body").prepend(
                '<video id="video_' +
                    extension.videos[0].id +
                    // '" style="min-width: 766px; min-height: 640px;" class="video-js vjs-big-play-centered"></video>'
                    '" style="width:100%; min-height: 580px;" class="video-js vjs-big-play-centered"  playsinline webkit-playsinline x5-video-player-type="h5" x5-video-player-fullscreen="false"></video>'
            );
            var urls = [];
            for (var i = 0; i < extension.videos[0].versions.length; i++) {
                if (extension.videos[0].versions[i].url)
                    urls.push(extension.videos[0].versions[i].url);
            }
            urls.sort(function (a, b) {
                if (a.substr(-5) == ".m3u8") return -1;
                else if (b.substr(-5) == ".m3u8") return 1;
                else return 0;
            });
            // console.log(urls);
            // urls[0] =
            //     "/cms/ybmedia/2026-05-16/235564514/712ABA0AC83C9CEE05B2EA7B4A0861AAM3U8.m3u8";
            var play = startPlay(urls[0], "video_" + extension.videos[0].id);
            players.push(play);
        } else {
            $("#content_body").html(
                '<div class="non-existent">视频已被删除</div>'
            );
        }
        $(".like-button").css("display", "block");
    } else if (type == "live") {
        if (extension !== undefined && extension != null) {
            $("#content_body").prepend(
                '<div id="content" style="width: 668px; height: 534px;"></div>'
            );
            var data = getLives(extension.live_id);
            if (data[0]) {
                var urls = [];
                urls.push(data[0].rtmpUrl);
                urls.push(data[0].flvUrl);
                urls.push(data[0].m3u8Url);

                var play;
                play = startPlay(urls[0], "content", false);
                players.push(play);
            }
        }
    } else if (type == "pictureset") {
        if (extension !== undefined && extension != null) {
            var data = getPicturesets(extension.pictureset_id);
            if (data[0]) {
                var html = "";
                // for (var i = 0; i < data[0].pictures.length; i++) {
                //     html += '<div class="art-pictureset">';
                //     html += '<img src="' + data[0].pictures[i].url + '" width="' + data[0].pictures[i].width + '" height="' + data[0].pictures[i].height + '" />';
                //     html += '<br />';
                //     html += '<span>' + data[0].pictures[i].introduction + '</span>';
                //     html += '</div>';
                // }
                if (data[0].pictures.length == 1) {
                    html +=
                        '<img src="' +
                        data[0].pictures[0].url +
                        '?w=720&h=0&s=1" />';
                } else if (data[0].pictures.length > 1) {
                    html += '<div class="big-img"><img /></div>';
                    html += '<div class="nav-imgs"><ul>\n';
                    for (var i = 0; i < data[0].pictures.length; i++) {
                        var info = data[0].pictures[i];
                        html +=
                            '<li class="nav-img"><img src="' +
                            info.url +
                            '?w=54&h=54&s=3" /></li>\n';
                    }
                    html += "</ul></div>\n";
                }
                $("#content_body").prepend(html);
            }
        }
        $(".like-button").css("display", "block");
    } else if (type == "questionnaire") {
        infoAnonymous = extension.anonymous;
        eventStart = extension.start_time;
        eventEnd = extension.stop_time;

        $("#content_body").html(html);
    } else if (type == "vote") {
        infoAnonymous = extension.anonymous;
        if (extension.strategies) {
            for (var i = 0; i < extension.strategies.length; i++) {
                if (extension.strategies[i].type == 2) {
                    dayLimit = extension.strategies[i].day_limit;
                    totalLimit = extension.strategies[i].total_limit;
                }
            }
        }
        eventStart = extension.start_time;
        eventEnd = extension.stop_time;
    } else if (type == "special") {
    } else if (type == "signup") {
        infoAnonymous = extension.anonymous;
        enableCaptcha = extension.enable_captcha;
        eventStart = extension.start_time;
        eventEnd = extension.stop_time;
    } else if (type == "audio") {
        if (extension && extension.audios.length > 0) {
            $("#content_body").html(
                '<div id="content" style="width: 668px; height: 534px;"></div>'
            );
            //   var play = new DsFlashPlayer();
            var obj = {
                nAppWidth: 500,
                cover_url: extension.audios[0].cover_url,
                strTitle: extension.audios[0].title,
                strAudioUrl: extension.audios[0].versions[0].url,
                blNeedUI: true,
            };
            var play;
            play = startPlay(obj.strAudioUrl, "content", false);
            players.push(play);
        }
    } else if (type == "show") {
    }

    for (var i = 0; i < players.length; i++) {
        players[i].on("play", function () {
            console.log("视频开始播放");
            for (var j = 0; j < players.length; j++) {
                if (this.id_ != players[j].id_) {
                    players[j].pause();
                }
            }
        });
    }

    $("input").iCheck({
        checkboxClass: "icheckbox_square-red",
        radioClass: "iradio_square-red",
    });

    $(".like-button").on("click", function () {
        if ($(this).hasClass("clicked")) return;
        else {
            if ($(".top .top-login").length > 0) {
                showLogin();
            } else {
                onLike();
            }
        }
    });

    $(".big-img").on("mousemove", function (event) {
        var x = event.offsetX;
        if (x < event.target.clientWidth / 2) {
            $(".big-img").removeClass("mouseright");
            $(".big-img").addClass("mouseleft");
        } else {
            $(".big-img").removeClass("mouseleft");
            $(".big-img").addClass("mouseright");
        }
    });

    $(".big-img").on("click", function (event) {
        if ($(".big-img").hasClass("mouseleft")) {
            imageClick($(".nav-img.selected").prev());
        } else if ($(".big-img").hasClass("mouseright")) {
            imageClick($(".nav-img.selected").next());
        }
    });

    $(".nav-img").on("click", function () {
        if ($(this).hasClass("selected")) {
            return;
        }
        imageClick($(this));
    });

    if ($(".nav-imgs .nav-img").length > 0) {
        $(".nav-imgs .nav-img:first").click();
    }

    if (eventStart && eventEnd) {
        if (eventStart > eventEnd) {
            alert("活动时间未确定!");
            $(".art-submit").css("display", "none");
            $("#content_body *").attr("disabled", true);
            return;
        } else if (now < eventStart) {
            alert("活动未开始!");
            $(".art-submit").css("display", "none");
            $("#content_body *").attr("disabled", true);
            return;
        } else if (now >= eventEnd) {
            alert("活动已结束!");
            $(".art-submit").css("display", "none");
            $("#content_body *").attr("disabled", true);
            return;
        }
    }

    if (!infoAnonymous) {
        if ($(".top .top-login").length > 0) {
            showLogin();
        }
    }

    if (enableCaptcha) {
        code.createCode();
        $(".checkcode").css("display", "block");
    }
});
function initCnzz() {
    // 创建CNZZ统计容器
    var cnzzSpan = document.createElement("span");
    cnzzSpan.id = "cnzz_stat_icon_541507";
    cnzzSpan.style.display = "none";
    document.body.appendChild(cnzzSpan);
    // 动态加载CNZZ统计脚本
    var script = document.createElement("script");
    script.src = "https://s5.cnzz.com/z.js?id=541507&show=pic";
    script.type = "text/javascript";
    script.async = true;
    cnzzSpan.appendChild(script);
}
function imageClick(item) {
    if (item.length == 0) {
        return;
    }

    $(".nav-img.selected").removeClass("selected");
    item.addClass("selected");
    var url = item.children().attr("src");
    if (url.indexOf("?") > 0) {
        url = url.substr(0, url.indexOf("?"));
    }
    $(".big-img img").attr("src", url);
}

function LastImage() {
    imageClick($(".nav-img.selected").prev());
}

function NextImage() {
    imageClick($(".nav-img.selected").next());
}

function onLike() {
    var id = $("#info_id").val();
    $.ajax({
        type: "post",
        async: true,
        url: ROOT + "/a/like?id=" + id,
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (data !== undefined && data.message !== undefined) {
                console.log(data);
                alert(data.message);
                return;
            } else {
                $(".like-button").addClass("clicked");
            }
        },
        error: function (data) {
            if (data.message !== undefined) {
                console.log(data.message);
                alert("点赞失败:" + data.message);
            } else {
                console.log(data);
                alert("点赞失败");
            }
        },
    });
}

$(window).scroll(function () {
    // 下面这句主要是获取网页的总高度，主要是考虑兼容性所以把Ie支持的documentElement也写了，这个方法至少支持IE8
    var htmlHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
    // clientHeight是网页在浏览器中的可视高度，
    var clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
    // scrollTop是浏览器滚动条的top位置，
    var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
    // 通过判断滚动条的top位置与可视网页之和与整个网页的高度是否相等来决定是否加载内容；
    if (scrollTop + clientHeight >= htmlHeight) {
        getReply();
    }

    // if ($('.banner').length > 0 && scrollTop < 398) {
    //     $('.abs-left').css({
    //         position: 'absolute',
    //         top: 0,
    //     });
    // } else {
    //     $('.abs-left').css({
    //         position: 'fixed',
    //         top: '48px',
    //     });
    // }
});

// 获取专题内容
$(function () {
    for (var i = 0; i < $(".art-special-content").length; i++) {
        var id = $($(".art-special-content")[i]).attr("contentid");
        $.ajax({
            type: "get",
            async: true,
            url: ROOT + "/a/contents?id=" + id,
            data: null,
            contentType: "application/json",
            dataType: "json",
            success: function (data) {
                if (data !== undefined && data.message !== undefined) {
                    console.log(data);
                    return;
                }

                var newlist = "";
                for (var j = 0; j < data.length; j++) {
                    var info = data[j];
                    if (
                        info.thumbnail_urls === undefined ||
                        info.thumbnail_urls == null ||
                        info.thumbnail_urls == ""
                    )
                        info.thumbnail_urls = [];
                    if (info.type == 4) {
                        newlist += '<div class="newsItem">';
                        newlist += '<div class="news_body">';
                        newlist +=
                            '<a class="news_title" href="' +
                            info.url +
                            '" target="_blank">' +
                            info.title +
                            "</a>";
                        newlist += "</div>";
                        newlist += '<div class="newsPicture">';
                        for (var j = 0; j < info.thumbnail_urls.length; j++) {
                            if (j == 4) break;
                            newlist +=
                                '<a href="' +
                                info.url +
                                '" target="_blank"><img src="' +
                                info.thumbnail_urls[j] +
                                "?w=156&h=102&s=3" +
                                '"/></a>';
                        }
                        newlist += "</div>";
                        newlist += '<div class="news_info">';
                        newlist +=
                            '<div class="user">' +
                            info.author_nickname +
                            "</div>";
                        newlist +=
                            '<div class="time">' + info.publish_time + "</div>";
                        newlist += '<div class="reply">';
                        if (info.comment_count > 0)
                            newlist +=
                                '<div class="reply_count">' +
                                info.comment_count +
                                "评论</div>";
                        if (info.view_count > 0)
                            newlist +=
                                '<div class="reply_count">' +
                                info.view_count +
                                "浏览</div>";
                        newlist += "</div>";
                        newlist += "</div>";
                        newlist += "</div>";
                    } else {
                        newlist += '<div class="newsItem">';
                        if (info.thumbnail_urls.length > 0) {
                            newlist += '<div class="newsPicture">';
                            newlist +=
                                '<a href="' +
                                info.url +
                                '" target="_blank"><img src="' +
                                info.thumbnail_urls[0] +
                                "?w=156&h=102&s=3" +
                                '"/></a>';
                            newlist += "</div>";
                        } else if (info.publisher_avatar_url) {
                            newlist += '<div class="newsPicture">';
                            newlist +=
                                '<a href="' +
                                info.url +
                                '" target="_blank"><img src="' +
                                info.publisher_avatar_url +
                                "?w=156&h=102&s=3" +
                                '"/></a>';
                            newlist += "</div>";
                        }
                        newlist += '<div class="alignMiddle">';
                        newlist += '<div class="newsInfo">';
                        newlist += '<div class="news_body">';
                        newlist +=
                            '<a class="news_title" href="' +
                            info.url +
                            '" target="_blank">' +
                            info.title +
                            "</a>";
                        newlist +=
                            '<span class="news_summary">' +
                            info.summary +
                            "</span>";
                        newlist += "</div>";
                        newlist += "</div>";
                        newlist += "</div>";
                        newlist += "</div>";
                        newlist += "</div>";
                    }
                }

                $($(".art-special-content")[i]).html(newlist);
            },
            error: function (data) {
                console.log(data);
            },
        });
    }

    // for (var i = 0; i < $('.art-special-video').length; i++) {
    //     var id = $($('.art-special-video')[i]).attr('contentid');
    //     $.ajax({
    //         type: 'get',
    //         async: true,
    //         url: ROOT + '/config/video?id=' + id,
    //         data: null,
    //         contentType: 'application/json',
    //         dataType: 'json',
    //         success: function (data) {
    //             if (data !== undefined && data.message !== undefined) {
    //                 console.log(data);
    //                 return;
    //             }
    //
    //             var newlist = '';
    //             for (var j = 0; j < data.length; j++) {
    //                 var info = data[j];
    //                 newlist += '<div class="art-special-video-item">';
    //                 newlist += '<div class="art-special-data" data=\'' + JSON.stringify(info) + '\'>';
    //                 newlist += '<img class="art-special-content-video-cover" src="' + info.cover_url + '" />';
    //                 newlist += '<img src="' + ROOT + '/static/images/play.png" class="play-btn" />';
    //                 newlist += '</div>';
    //                 newlist += '</div>';
    //             }
    //
    //             $($('.art-special-video')[i]).html(newlist);
    //         },
    //         error: function (data) {
    //             console.log(data);
    //         }
    //     });
    // }
    //
    // for (var i = 0; i < $('.art-special-pictureset').length; i++) {
    //     var id = $($('.art-special-pictureset')[i]).attr('contentid');
    //     $.ajax({
    //         type: 'get',
    //         async: true,
    //         url: ROOT + '/config/pictureset?id=' + id,
    //         data: null,
    //         contentType: 'application/json',
    //         dataType: 'json',
    //         success: function (data) {
    //             if (data !== undefined && data.message !== undefined) {
    //                 console.log(data);
    //                 return;
    //             }
    //
    //             var newlist = '';
    //             for (var j = 0; j < data.length; j++) {
    //                 var info = data[j];
    //                 newlist += '<div class="art-special-pictureset-item">';
    //                 newlist += '<div class="art-special-data" data=\'' + JSON.stringify(info) + '\'>';
    //                 for (var k = 0; k < info.pictures.length; k++) {
    //                     newlist += '<img class="art-special-pictureset-img" src="' + info.pictures[k].url + '" />';
    //                 }
    //                 newlist += '</div>';
    //                 newlist += '</div>';
    //             }
    //
    //             $($('.art-special-pictureset')[i]).html(newlist);
    //         },
    //         error: function (data) {
    //             console.log(data);
    //         }
    //     });
    // }
    //
    // for (var i = 0; i < $('.art-special-vote').length; i++) {
    //     var id = $($('.art-special-vote')[i]).attr('contentid');
    //     $.ajax({
    //         type: 'get',
    //         async: true,
    //         url: ROOT + '/a/contents?id=' + id,
    //         data: null,
    //         contentType: 'application/json',
    //         dataType: 'json',
    //         success: function (data) {
    //             if (data !== undefined && data.message !== undefined) {
    //                 console.log(data);
    //                 return;
    //             }
    //
    //             var newlist = '';
    //             for (var j = 0; j < data.length; j++) {
    //                 var info = data[j];
    //
    //                 vote += '<div class="art-votes" dataid="' + exdata.id + '">';
    //                 for (var i = 0; i < exdata.topics.length; i++) {
    //                     var info = exdata.topics[i];
    //
    //                     vote += '<div class="art-vote" dataid="' + info.id + '">';
    //                     vote += '<div class="art-vote-number">' + (i + 1) + '</div>';
    //                     vote += '<div class="art-vote-title">';
    //                     if (info.option_type == 1)
    //                         vote += '<img src="' + ROOT + '/static/images/u620.png" />';
    //                     else if (info.option_type == 2)
    //                         vote += '<img src="' + ROOT + '/static/images/u624.png" />';
    //                     else if (info.option_type == 3)
    //                         vote += '<img src="' + ROOT + '/static/images/u622.png" />';
    //                     vote += info.title;
    //                     vote += '</div>';
    //                     vote += '<div class="art-vote-options">';
    //
    //                     for (var j = 0; j < info.options.length; j++) {
    //                         if (info.option_type == 1) {
    //                             vote += '<div class="art-vote-option text">';
    //                             vote += '<input type="radio" name="vote' + info.id + '" value="' + info.options[j].id + '" />' + info.options[j].title;
    //                             if (info.result_type == 1)
    //                                 vote += '<div class="art-vote-result">(' + info.options[j].count + '票)</div>';
    //                             else if (info.result_type == 2)
    //                                 vote += '<div class="art-vote-result">(' + info.options[j].count + '名)</div>';
    //                             vote += '</div>';
    //                         } else if (info.option_type == 2) {
    //                             vote += '<div class="art-vote-option pic">';
    //                             vote += '<div class="art-vote-pic">';
    //                             vote += '<img src="' + info.options[j].picture_url + '" width="216" height="216" />';
    //                             vote += '</div>';
    //                             vote += '<div class="art-vote-checkbox">';
    //                             vote += '<input type="radio" name="vote' + info.id + '" value="' + info.options[j].id + '" />' + info.options[j].title;
    //                             vote += '</div>';
    //                             if (info.result_type == 1)
    //                                 vote += '<div class="art-vote-result">(' + info.options[j].count + '票)</div>';
    //                             else if (info.result_type == 2)
    //                                 vote += '<div class="art-vote-result">(' + info.options[j].count + '名)</div>';
    //                             vote += '</div>';
    //                         } else if (info.option_type == 3) {
    //                             vote += '<div class="art-vote-option video">';
    //                             vote += '<div class="art-vote-video" id="video' + info.options[j].video.id + '" videoid="' + info.options[j].video.id + '">';
    //                             vote += '<img src="' + info.options[j].video.cover_url + '" width="216" height="216" />';
    //                             vote += '<img src="' + ROOT + '/static/images/play.png" class="play-btn" />';
    //                             if (info.options[j].video.versions && info.options[j].video.versions.length > 0) {
    //                                 for (var k = 0; k < info.options[j].video.versions.length; k++) {
    //                                     vote += '<input type="hidden" name="video' + info.options[j].video.id + '" value="' + info.options[j].video.versions[k].url + '">';
    //                                 }
    //                             }
    //                             vote += '</div>';
    //                             vote += '<div class="art-vote-checkbox">';
    //                             vote += '<input type="radio" name="vote' + info.id + '" value="' + info.options[j].id + '" />' + info.options[j].title;
    //                             vote += '</div>';
    //                             if (info.result_type == 1)
    //                                 vote += '<div class="art-vote-result">(' + info.options[j].count + '票)</div>';
    //                             else if (info.result_type == 2)
    //                                 vote += '<div class="art-vote-result">(' + info.options[j].count + '名)</div>';
    //                             vote += '</div>';
    //                         }
    //                     }
    //                     vote += '</div>';
    //                     vote += '</div>';
    //                 }
    //                 vote += '</div>';
    //
    //             }
    //
    //             $($('.art-special-vote')[i]).html(newlist);
    //         },
    //         error: function (data) {
    //             console.log(data);
    //         }
    //     });
    // }
});

$(function () {
    $(".art-submit").on("click", function () {
        if (!infoAnonymous) {
            if ($(".top .top-login").length > 0) {
                showLogin();
            }
        }

        if (eventEnd) {
            alert("活动已结束!");
            return;
        }

        if (enableCaptcha) {
            if (code.validate()) {
                if ($("#info_type").val() == "questionnaire") submitQuestion();
                else if ($("#info_type").val() == "vote") submitVote();
                else if ($("#info_type").val() == "signup") submitSignup();
            }
        } else {
            if ($("#info_type").val() == "questionnaire") submitQuestion();
            else if ($("#info_type").val() == "vote") submitVote();
            else if ($("#info_type").val() == "signup") submitSignup();
        }
    });
});

// 投票视频、图片点击处理
$(function () {
    $(".art-vote-video").on("click", function () {
        var video = $(this).attr("id");
        var urls = [];
        if ($('input[name="' + video + '"]').length > 0) {
            for (var i = 0; i < $('input[name="' + video + '"]').length; i++) {
                urls.push($('input[name="' + video + '"]')[i].value);
            }
        }

        $("#viewcontent").html("");
        $("#videoviewdlg").modal("show");

        var play;
        play = startPlay(urls[0], "viewcontent", false);
        players.push(play);
    });

    $(".art-special-video-item").on("click", function () {
        try {
            var data = $(this).children(".art-special-data").attr("data");
            data = JSON.parse(data);
            if (data.versions && data.versions.length > 0) {
                var urls = [];
                for (var i = 0; i < data.versions.length; i++) {
                    urls.push(data.versions[i].url);
                }

                $("#viewcontent").html("");
                $("#videoviewdlg").modal("show");
                var play;
                play = startPlay(urls[0], "viewcontent", false);
                players.push(play);
            }
        } catch (e) {
            console.log(e);
            return;
        }
    });

    $("#closeplayer").on("click", function () {
        $("#videoviewdlg").modal("hide");
        $("#viewcontent").html("");
    });
});

// 提交问卷
function submitQuestion() {
    var id = $(".art-questionnaire").attr("dataid");

    var data = [];
    for (var i = 0; i < $(".art-question").length; i++) {
        var ids = [];
        var otherbool = false;
        var othertext = "";
        var text = "";
        for (
            var j = 0;
            j < $($(".art-question")[i]).find("input:checked").length;
            j++
        ) {
            if (
                $($(".art-question")[i]).find("input:checked")[j].value !=
                "other"
            ) {
                ids.push(
                    $($(".art-question")[i]).find("input:checked")[j].value
                );
            } else {
                othertext = $($($(".art-question")[i]).find("input:checked")[j])
                    .parent()
                    .next()
                    .val();
                if (othertext != "") otherbool = true;
            }
        }
        if (
            $($(".art-question")[i]).find(
                ".art-question-input .art-question-text"
            ).length > 0
        )
            text = $($(".art-question")[i]).find(
                ".art-question-input .art-question-text"
            )[0].value;
        var answer = {
            question_id: $($(".art-question")[i]).attr("dataid"),
            text: text,
            selected_option_ids: ids,
            other_option_selected: otherbool,
            other_option_text: othertext,
        };
        data.push(answer);
    }

    $.ajax({
        type: "post",
        async: true,
        url: ROOT + "/a/questionnaire?id=" + id,
        data: JSON.stringify(data),
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (data !== undefined && data.message !== undefined) {
                console.log(data);
                alert(data.message);
                return;
            } else {
                alert("问卷已提交");
                location.reload();
                return;
            }
        },
        error: function (data) {
            console.log(data);
        },
    });
}

// 提交投票
function submitVote() {
    var id = $(".art-votes").attr("dataid");

    var data = [];
    for (var i = 0; i < $(".art-vote").length; i++) {
        var topic = {
            id: $($(".art-vote")[i]).attr("dataid"),
            selected_option_id: $($(".art-vote")[i])
                .find("input:checked")
                .val(),
        };
        data.push(topic);
    }

    $.ajax({
        type: "post",
        async: true,
        url:
            ROOT +
            "/a/vote?id=" +
            id +
            "&day=" +
            dayLimit +
            "&total=" +
            totalLimit,
        data: JSON.stringify(data),
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (data !== undefined && data.message !== undefined) {
                console.log(data);
                alert(data.message);
                return;
            } else {
                alert("投票已提交");
                location.reload();
                return;
            }
        },
        error: function (data) {
            console.log(data);
        },
    });
}

// 提交报名
function submitSignup() {
    var id = $(".art-signups").attr("dataid");

    var data = [];
    for (var i = 0; i < $(".art-signup").length; i++) {
        var text = "";
        var ids = [];
        var pic = "";
        var video = "";

        if ($($(".art-signup")[i]).find(".art-signup-text").length > 0) {
            text = $($(".art-signup")[i])
                .find(".art-signup-text")
                .children("input")
                .val();
        }
        if ($($(".art-signup")[i]).find(".art-signup-options").length > 0) {
            var children = $($(".art-signup")[i])
                .find(".art-signup-options")
                .find("input:checked");
            for (var j = 0; j < children.length; j++) {
                ids.push(children[j].value);
            }
        }
        if ($($(".art-signup")[i]).find(".art-signup-pic").length > 0) {
            pic = $($(".art-signup")[i])
                .find(".art-signup-pic")
                .children("input")
                .val();
        }
        if ($($(".art-signup")[i]).find(".art-signup-video").length > 0) {
            video = $($(".art-signup")[i])
                .find(".art-signup-video")
                .children("input")
                .val();
        }

        var field = {
            id: $($(".art-signup")[i]).attr("dataid"),
            text: text,
            selected_option_ids: ids,
            picture_path: pic,
            video_path: video,
        };
        data.push(field);
    }

    $.ajax({
        type: "post",
        async: true,
        url: ROOT + "/a/signup?id=" + id,
        data: JSON.stringify(data),
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (data !== undefined && data.message !== undefined) {
                console.log(data);
                alert(data.message);
                return;
            } else {
                alert("报名已提交");
                location.reload();
                return;
            }
        },
        error: function (data) {
            console.log(data);
        },
    });
}

function uploadid(id) {
    $("#uploadid").val(id);
}

function uploads(file, type) {
    if (!file.files || !file.files[0]) {
        alert("读取文件失败");
        return;
    }
    var id = $("#uploadid").val();
    if (!id) return;
    var url = "/config/pic_uploader";
    var uploader = "#pic_uploader";
    if (type == 1) {
        url = "/config/video_uploader";
        uploader = "#video_uploader";
    }
    var reader = new FileReader();
    reader.onload = function (evt) {
        $.ajax({
            type: "get",
            async: true,
            url: url,
            data: {},
            contentType: "application/json",
            dataType: "json",
            success: function (data) {
                if (data !== undefined && data.message !== undefined) {
                    alert("获取上传地址失败:" + data.message);
                    return;
                }
                showwait();
                $(uploader).ajaxSubmit({
                    url: data,
                    type: "post",
                    success: function (rs) {
                        hidewait();
                        if (rs !== undefined) {
                            if (rs.isOK == 1) {
                                $("#signup" + id).text(file.files[0].name);
                                $("input[name=signup" + id + "]").val(
                                    rs.relativepath + rs.name
                                );
                            } else if (rs.errMessage !== undefined) {
                                console.log(rs.errMessage);
                                alert("上传失败:" + rs.errMessage);
                            } else {
                                console.log(rs);
                                alert("上传失败");
                            }
                        }
                    },
                    error: function (data) {
                        hidewait();
                        console.log(data);
                        alert("上传异常");
                    },
                });
            },
            error: function (data) {
                if (data.message !== undefined) {
                    console.log(data.message);
                    alert("获取上传地址失败:" + data.message);
                } else {
                    console.log(data);
                    alert("获取上传地址失败");
                }
            },
        });
    };
    reader.readAsDataURL(file.files[0]);
}

function getNewest() {
    $.ajax({
        type: "get",
        async: true,
        url: ROOT + "/home/newest",
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            var newlist = "";
            for (var i = 0; i < data.length; i++) {
                var info = data[i];

                newlist += '<div class="newest-item">';
                newlist += '<div class="newest-item-img">';
                newlist += '<a href="' + info.url + '">';
                if (
                    info.thumbnail_urls &&
                    info.thumbnail_urls.length > 0 &&
                    info.thumbnail_urls[0]
                ) {
                    newlist +=
                        '<img src="' +
                        info.thumbnail_urls[0] +
                        '?w=242&h=152&s=3"/>';
                } else {
                    newlist +=
                        '<img src="' + ROOT + '/static/images/no-thumb.png"/>';
                }
                newlist += "</a>";
                newlist += "</div>";
                newlist += '<div class="newest-item-tilte">';
                newlist += '<a href="' + info.url + '">' + info.title + "</a>";
                newlist += "</div>";
                newlist +=
                    '<div class="newest-item-time">' +
                    info.publish_time +
                    "</div>";
                newlist += "</div>";
            }

            $(".newest .newest-list").html(newlist);
        },
        error: function (data) {
            console.log(data);
        },
    });
}

function getCorrelates() {
    var id = $(".correlates-change").attr("dataid");
    $.ajax({
        type: "get",
        async: true,
        url: ROOT + "/home/correlates?id=" + id,
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            var newlist = "";
            for (var i = 0; i < data.length; i++) {
                var info = data[i];

                newlist += '<div class="correlates-item">';
                newlist += '<div class="correlates-item-img">';
                newlist += '<a href="' + info.url + '">';
                if (
                    info.thumbnail_urls &&
                    info.thumbnail_urls.length > 0 &&
                    info.thumbnail_urls[0]
                ) {
                    newlist +=
                        '<img src="' +
                        info.thumbnail_urls[0] +
                        '?w=210&h=132&s=3"/>';
                } else {
                    newlist +=
                        '<img src="' + ROOT + '/static/images/no-thumb.png"/>';
                }
                newlist += "</a>";
                newlist += "</div>";
                newlist += '<div class="correlates-item-tilte">';
                newlist += '<a href="' + info.url + '">' + info.title + "</a>";
                newlist += "</div>";
                newlist +=
                    '<div class="correlates-item-time">' +
                    info.publish_time +
                    "</div>";
                newlist += "</div>";
            }
            if (data.length % 3 != 0) {
                for (var i = 0; i < data.length % 3; i++) {
                    newlist += '<div class="correlates-item"></div>';
                }
            }

            $(".correlates .correlates-list").html(newlist);
        },
        error: function (data) {
            console.log(data);
        },
    });
}
function getDownloadInfo() {
    $.ajax({
        type: "get",
        async: true,
        url: ROOT + "/home/ad-position?key=gx_dw",
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            console.log(data);
            var ad = data.gx_dw;

            $.ajax({
                type: "get",
                async: true,
                url: ROOT + "/home/apps",
                data: null,
                contentType: "application/json",
                dataType: "json",
                success: function (apps) {
                    console.log(apps);

                    var adHtml = "";
                    if (ad && ad.ads && ad.ads.length > 0) {
                        var url = "javascript:;";
                        var target = "_self";
                        if (ad.ads[0].link_url) {
                            url = ad.ads[0].link_url;
                            target = "_blank";
                        }
                        var img = "/cms/static/images/defaultImg.png";
                        if (ad.ads[0].picture_url) {
                            img = ad.ads[0].picture_url;
                        }
                        adHtml +=
                            '<a href="' + url + '" target="' + target + '" >';
                        adHtml +=
                            '<img src="' +
                            img +
                            '?w=1200&h=70&s=3" alt=""  width="1200" height="70" />';
                        adHtml += "</a>";
                        adHtml +=
                            ' <a class="appDowload" href="' +
                            apps.download_url +
                            '" target="_blank" rel="noopener noreferrer"></a>';
                    }
                    $(" .ad_box").html(adHtml);
                },
                error: function (data) {
                    console.log(data);
                },
            });
        },
        error: function (data) {
            console.log(data);
        },
    });
}

function getAds() {
    $.ajax({
        type: "get",
        async: true,
        url: ROOT + "/home/ad-position?key=yibin_content",
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            let { ads } = data.yibin_content || {};
            if (ads && ads.length) {
                let adHtml = "";
                for (let i = 0; i < ads.length; i++) {
                    let item = ads[i];
                    adHtml += '<div class="article-ad">';
                    adHtml +=
                        '<a class="article-ad-link" href="' +
                        item.link_url +
                        '">';
                    adHtml += '<img src="' + item.picture_url + '" />';
                    adHtml += "</a>";
                    adHtml += "</div>";
                }
                $(".article-ads").html(adHtml);
            }
        },
        error: function (data) {
            console.log(data);
        },
    });
}

function getHots() {
    let stop = Math.round(new Date().getTime() / 1000);
    let start = stop - 7 * 24 * 60 * 60;
    $.ajax({
        type: "get",
        // async: true,
        url:
            ROOT +
            "/home/contents/sorted?sort=view:desc" +
            "&page=1&size=4&start=" +
            start +
            "&stop=" +
            stop,
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function ({ data }) {
            if (!data || data.length == 0) {
                return;
            }
            var hostList = "";
            for (let i = 0; i < data.length; i++) {
                var item = data[i];
                item.url = `/cms/a/${item.id}/content`;
                hostList += '<div class="week-rank-item">';
                hostList += '<a href="' + item.url + '" target="_blank">';
                hostList +=
                    '<div class="week-rank-item-title ellipse">' +
                    item.title +
                    "</div>";
                hostList += "</a>";
                hostList += "</div>";
            }
            $(".week-rank-list").html(hostList);
        },
        error: function (data) {
            console.log(data);
        },
    });
}

function getTabNews(types = "video") {
    let stop = Math.round(new Date().getTime() / 1000);
    let start = stop - 7 * 24 * 60 * 60;
    // let start = stop - 30 * 24 * 60 * 60;
    // let start = "";
    $.ajax({
        type: "get",
        // async: true,
        url:
            ROOT +
            "/home/contents/sorted?sort=view:desc" +
            "&page=1&size=2&start=" +
            start +
            "&stop=" +
            stop +
            "&types=" +
            types,
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function ({ data }) {
            if (!data || data.length == 0) {
                $(".news-tab-list").html("");
                return;
            }
            var hostList = "";
            for (let i = 0; i < data.length; i++) {
                var item = data[i];
                var img = "/cms/static/images/defaultImg.png";
                if (item.thumbnail_urls[0]) {
                    img = item.thumbnail_urls[0];
                }
                item.url = `/cms/a/${item.id}/content`;
                hostList += '<div class="news-tab-item">';
                hostList += '<a href="' + item.url + '" target="_blank">';
                hostList += '<img src="' + img + '" />';
                hostList +=
                    '<div class="news-tab-item-title ellipse">' +
                    item.title +
                    "</div>";
                hostList += "</a>";
                hostList += "</div>";
            }
            $(".news-tab-list").html(hostList);
        },
        error: function (data) {
            console.log(data);
        },
    });
}
